export * from './IconHandshakeGradient';
export { default as IconHandshakeGradient } from './IconHandshakeGradient';
